import { useEffect, useState } from "react";

// True once `active` has held for `ms`, false as soon as it drops.
export const useHasLasted = (active: boolean, ms: number) => {
  const [hasLasted, setHasLasted] = useState(false);
  useEffect(() => {
    setHasLasted(false);
    if (!active) {
      return;
    }
    const timer = setTimeout(() => setHasLasted(true), ms);
    return () => clearTimeout(timer);
  }, [active, ms]);
  return active && hasLasted;
};
